"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
var tslib_1 = require("tslib");
var container_1 = require("./container");
/**
 * Created by wangtong on 2021/1/4
 */
var Tree;
(function (Tree) {
    // 摊平的数组转成树
    function flatToTree(flat, config) {
        var primary_key = (config === null || config === void 0 ? void 0 : config.primary_key) || 'id';
        var root = []; // 根节点
        flat = flat.map(function (item) {
            if (config === null || config === void 0 ? void 0 : config.wrapper) {
                return config.wrapper(item);
            }
            else {
                return tslib_1.__assign({ children: [] }, item);
            }
        });
        var dict_index = container_1.List.toDictIndex(flat, primary_key);
        flat.forEach(function (value) {
            var parent_id = value.parent_id || 0;
            if (!dict_index.hasOwnProperty(parent_id)) {
                // 是根节点
                root.push(value);
            }
            else {
                var parent_1 = flat[dict_index[parent_id]];
                if (parent_1.children) {
                    parent_1.children.push(value);
                }
                else {
                    parent_1.children = [value];
                }
            }
        });
        return root;
    }
    Tree.flatToTree = flatToTree;
    // 树转成摊平的数组
    function treeToFlat(tree, config) {
        var flat = [];
        Tree.traverse(tree, function (value, parent, root) {
            var new_value;
            var parent_id = parent === null ? 0 : parent.id;
            if (config === null || config === void 0 ? void 0 : config.wrapper) {
                new_value = config.wrapper(value);
                new_value.parent_id = parent_id;
            }
            else {
                new_value = tslib_1.__assign(tslib_1.__assign({}, value), { parent_id: parent_id });
            }
            if (config === null || config === void 0 ? void 0 : config.remove_children) {
                delete new_value.children;
            }
            flat.push(new_value);
        });
        return flat;
    }
    Tree.treeToFlat = treeToFlat;
    function traverse() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var tree = args[0];
        var callback = args[1];
        var root = tree;
        var parent = null;
        if (args.length == 4) {
            parent = args[2];
            root = args[3];
        }
        tree.forEach(function (item, index) {
            callback(item, parent, root, index);
            var children = item.children || [];
            if (children.length > 0) {
                Tree.traverse(children, callback, item, root);
            }
        });
    }
    Tree.traverse = traverse;
    function count(tree) {
        var c = 0;
        Tree.traverse((tree), function () {
            c += 1;
        });
        return c;
    }
    Tree.count = count;
    function filter() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var tree = args[0];
        var filterFunc = args[1];
        var config = args[2];
        var parent = args[3] || null;
        var root = args[4] || tree;
        var new_tree = [];
        tree.forEach(function (item, index) {
            // 先过滤子孙
            var children = item.children || [];
            if (children.length > 0) {
                children = Tree.filter(children, filterFunc, config, item, root);
            }
            if (children.length > 0 || filterFunc(item, parent, root, index)) {
                var new_item = tslib_1.__assign(tslib_1.__assign({}, item), { children: children });
                if (config === null || config === void 0 ? void 0 : config.wrapper) {
                    new_item = config.wrapper(new_item);
                }
                new_tree.push(new_item);
            }
        });
        return new_tree;
    }
    Tree.filter = filter;
    function map() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var new_tree = [];
        var tree = args[0];
        var mapFunc = args[1];
        var root = tree;
        var parent = null;
        if (args.length == 4) {
            parent = args[2];
            root = args[3];
        }
        tree.forEach(function (item, index) {
            var children = item.children || [];
            if (children.length > 0) {
                children = Tree.map(children, mapFunc, item, root);
            }
            var new_item = mapFunc(item, parent, root, index);
            new_tree.push(tslib_1.__assign(tslib_1.__assign({}, new_item), { children: children }));
        });
        return new_tree;
    }
    Tree.map = map;
    function sort() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var new_tree = [];
        var tree = args[0];
        var sortFn = args[1];
        var config = args[2];
        var parent = args[3] || null;
        var root = args[4] || tree;
        tree.forEach(function (item, index) {
            var children = item.children || [];
            if (children.length > 0) {
                children = Tree.sort(children, sortFn, config, item, root);
            }
            var new_item = tslib_1.__assign(tslib_1.__assign({}, item), { children: children });
            if (config === null || config === void 0 ? void 0 : config.wrapper) {
                new_item = config.wrapper(new_item);
            }
            new_tree.push(new_item);
        });
        new_tree = new_tree.sort(function (a, b) {
            return sortFn(a, b);
        });
        return new_tree;
    }
    Tree.sort = sort;
    function addItem(tree, mark, new_item) {
        var parent_tree = [];
        var id = 0;
        if (typeof mark === "object") {
            id = mark.id || 0;
        }
        else {
            id = mark;
        }
        Tree.traverse(tree, function (value, parent, root) {
            if (value.id === id) {
                if (parent) {
                    parent_tree = parent.children || [];
                }
                else if (root) {
                    parent_tree = root;
                }
            }
        });
        if (parent_tree) {
            var index = parent_tree.findIndex(function (v) { return v.id === id; });
            if (index > -1) {
                parent_tree.splice(index + 1, 0, new_item);
            }
            else {
                parent_tree.push(new_item);
            }
        }
    }
    Tree.addItem = addItem;
    function removeItem(tree, mark, removeItemCallback) {
        var match_parent = [];
        var id = 0;
        if (typeof mark === "object") {
            id = mark.id || 0;
        }
        else {
            id = mark;
        }
        Tree.traverse(tree, function (value, parent, root) {
            if (value.id === id) {
                if (parent) {
                    match_parent = parent.children || [];
                }
                else {
                    match_parent = root;
                }
            }
        });
        var index = match_parent.findIndex(function (p) { return p.id === id; });
        if (index > -1) {
            match_parent.splice(index, 1);
            if (removeItemCallback) {
                removeItemCallback(match_parent);
            }
        }
    }
    Tree.removeItem = removeItem;
})(Tree || (Tree = {}));
exports.Tree = Tree;
//# sourceMappingURL=tree.js.map